import { useState, useEffect } from "react";
import pageArray from "../components/Pagination/helpers/pageArray";
import { useMediaQuery } from "react-responsive";
import { Sizes } from "../styles";

const useFetch = (paramsString, lang, endPoint, ctaObj, cta2Obj) => {
	const [data, setData] = useState([]);
	const messageText = lang === "en" ? "Loading products" : "Chargement des produits";
	const [message, setMessage] = useState(messageText);
	const [totalPages, setTotalPages] = useState([]);
	const [postCount, setPostCount] = useState(0);

	const isDesktopOrLaptop = useMediaQuery({
		query: `(min-width: ${Sizes.screens.large})`,
	});

	const insertCTA = (items, ctaObj, cta2Obj) => {
		if (endPoint !== "products") return items;

		let itemsCopy = [...items];

		if (ctaObj) {
			const ctaIndex = isDesktopOrLaptop ? 5 : 2;
			const cta = {
				id: "cta",
				text: ctaObj.text,
				link: ctaObj.link.url,
				linkText: ctaObj.link.title,
				linkTarget: ctaObj.link.target,
			}
	
			if (itemsCopy.length >= ctaIndex) {
				itemsCopy.splice(ctaIndex, 0, cta);
			} else {
				itemsCopy = [...itemsCopy, cta];
			}
		}

		if (cta2Obj) {
			const cta2Index = isDesktopOrLaptop ? 9 : 6;
			const cta2 = {
				id: "cta",
				text: cta2Obj.text,
				link: cta2Obj.link.url,
				linkText: cta2Obj.link.title,
				linkTarget: cta2Obj.link.target,
			}
		
			if (itemsCopy.length >= cta2Index) {
				itemsCopy.splice(cta2Index, 0, cta2);
			} else {
				itemsCopy = [...itemsCopy, cta2];
			}
		}

		return itemsCopy;
	}

	const formatResponse = (response) => {
		if (!response.data) {
			const items = {
				data: [],
			};
			
			// formats the filters object into an array
			for (const key in response) {
				items.data.push(response[key]);
			}

			// inserts the "supported by BDC" object into the "Category" group
			const sponsored = items.data.pop();
			items.data[0].filters.push(sponsored.filters[0]);
			return items;
		}

		return response;
	}

	useEffect(() => {
		const request = {
			baseUrl: window.origin,
			endPoint: endPoint,
			paramsString: paramsString,
		}
		
		const url = `${request.baseUrl}/wp-json/fphsg/v1/${request.endPoint}?${request.paramsString}`;

		const fetchData = async () => {
			try {
				const response = await fetch(url);
				const encodedResponse = await response.json();
				const formattedResponse = formatResponse(encodedResponse);
				setMessage("");
				
				if (!formattedResponse.postCount) {
					setPostCount(0);
				}

				if (!formattedResponse.data.length) {
					setData([]);
					return;
				}
				
				if (formattedResponse.postCount) {
					setPostCount(formattedResponse.postCount);
					setTotalPages(pageArray(Math.ceil(formattedResponse.postCount / 19)));
				}
				
				const newItemsArray = insertCTA(formattedResponse.data, ctaObj, cta2Obj);
				setData(newItemsArray);
			} catch (error) {
				//eslint-disable-next-line
				console.log(error);
			}
		};

		fetchData();

	}, [paramsString]);

	return [data, message, totalPages, postCount];
}

export default useFetch;
